import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  SimpleReactValidator,
  API,
  toast,
  Title,
  Messages,
  FileUploadWithPreview,
  getBase64,
  Spinner,
  DataTable
} from '../../config/react'
import ReactSummernote from 'react-summernote'
import 'react-summernote/dist/react-summernote.css'
const AddBlog = () => {
  const urlParams = useParams()
  const history = useHistory()
  const submitbtnRef = useRef()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isForceUpdate, setForceUpdate] = useState(false)
  // const [IsShowImageRemoveLink, setIsShowImageRemoveLink] = useState(false)
  const [BlogImage, setBlogImage] = useState('')
  const validator = useRef(new SimpleReactValidator())
  const [Content, setContent] = useState('')
  const [, setMultipleBlogCatId] = useState()
  // const [Categories, setCategories] = useState([])
  const [IsValidFile, setValidFile] = useState(true)
  // const [IsImage, setIsImage] = useState(true)
  const [IsImageSize, setImageSize] = useState(false)
  const [Inputs, setInputs] = useState({
    id: 0,
    title: '',
    description: '',
    slug: '',
    image: '',
    meta_title: '',
    meta_description: '',
    status: 0,
    blog_category_id: '',
    info: '',
    image_alt: '',
    created_at: new Date().toISOString().slice(0, 16)
  })

  let SelectedBlogCatId = ''
  useEffect(() => {
    setIsAuth(true)
    setLoading(false)
    document.title = Title.AddBlog
    if (urlParams.id !== undefined) {
      GetBlogById()
      document.title = Title.EditBlog
    } else {
      setTimeout(() => {
        initImagePlugin()
      }, 1000)
    }
  }, [urlParams.id])
  const GetBlogById = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetBlogById, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0][0]
        data.created_at = data.created_at
          ? new Date(data.created_at).toISOString().slice(0, 16)
          : new Date().toISOString().slice(0, 16)
        setInputs(data)
        SelectedBlogCatId = DataTable.blog_category_id
        setMultipleBlogCatId(SelectedBlogCatId)

        setTimeout(() => {
          if (data.image !== '') {
            initImagePlugin(data.image)
          } else {
            initImagePlugin()
          }
          setContent(response.data.result[0][0].content)
        }, 1000)
        // initImagePlugin(data.image)

        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const initImagePlugin = (image = null) => {
    if (image !== '' && image !== null) {
      new FileUploadWithPreview('blogImages', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image]
      })
      // setIsImage(true)
    } else {
      new FileUploadWithPreview('blogImages', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  window.addEventListener('fileUploadWithPreview:imagesAdded', async function (e) {
    Inputs.info = e
    const imageType = e.detail.cachedFileArray[0].type
    const size = e.detail.cachedFileArray[0].size
    if (
      imageType === 'image/jpeg' ||
      imageType === 'image/jpg' ||
      imageType === 'image/png' ||
      imageType === 'image/webp'
    ) {
      if (size <= 2097152) {
        const image = await new Promise((resolve, reject) => {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            resolve(result)
          })
        })
        setBlogImage(image)
        // setIsImage(true)
        setValidFile(true)
        setImageSize(false)
      } else {
        setImageSize(true)
        // setIsImage(true)

        setBlogImage('')
      }
    } else {
      setBlogImage('')
      // setIsImage(true)
      setValidFile(false)
      setImageSize(false)
    }
  })

  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    setBlogImage('')
    setValidFile(true)
    setImageSize(false)
  })

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
    if (prop === 'title') {
      setInputs({
        ...Inputs,
        [prop]: event.target.value,
        slug: event.target.value.toLowerCase().replaceAll(/[\s&]/g, '-')
      })
    }
    setForceUpdate(!isForceUpdate)
  }

  // const updateCategoryDropdown = () => {
  //   if (urlParams.id !== undefined) {
  //     if (SelectedBlogCatId !== '') {
  //       var data = SelectedBlogCatId.split(',')
  //       Categories.map((item, index) => {
  //         const checked = data.filter((x) => x === item.value).length > 0
  //         Categories[index].checked = checked
  //         return true
  //       })
  //     } else {
  //       data = Inputs.blog_category_id.split(',')
  //       Categories.map((item, index) => {
  //         const checked = data.filter((x) => x === item.value).length > 0
  //         Categories[index].checked = checked
  //         return true
  //       })
  //     }
  //   } else {
  //     Categories.map((item, index) => {
  //       data = Inputs.blog_category_id.split(',')
  //       if (item.value === parseInt(data[index])) {
  //         Categories[index].checked = true
  //       } else {
  //         Categories[index].checked = false
  //       }
  //       return true
  //     })
  //   }
  // }
  const handleEditorChange = (e) => {
    setContent(e)

    setForceUpdate(!isForceUpdate)
  }
  // const onChangeCategory = (currentNode, selectedNodes) => {
  //   let selectCatId = ''
  //   if (selectedNodes.length > 0) {
  //     selectCatId = selectedNodes.map((x) => x.value).join(',')
  //   }
  //   Inputs.blog_category_id = selectCatId
  //   SelectedBlogCatId = selectCatId
  // }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    const param = {
      id: Inputs.id,
      title: Inputs.title,
      content: Content,
      description: Inputs.description,
      slug: Inputs.slug.trim(),
      image: BlogImage,
      status: Inputs.status ? 1 : 0,
      blog_category_id: Inputs.blog_category_id,
      meta_title: Inputs.meta_title,
      meta_description: Inputs.meta_description,
      created_at: Inputs.created_at,
      image_alt: Inputs.image_alt
    }

    setLoading(true)
    HttpService.postApi(API.SetBlog, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        if (response.data.message !== '') {
          initImagePlugin(BlogImage)
        }
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        submitbtnRef.current.removeAttribute('disabled')
        return
      }
      if (Inputs.id !== 0 && Inputs.id !== '') {
        toast.success(Messages.RecordUpdated)
      } else {
        toast.success(Messages.RecordAdded)
      }
      setForceUpdate(!isForceUpdate)
      history.push('/blog')
    })
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditBlog : Title.AddBlog}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Page Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        min="2"
                        maxLength="255"
                        onChange={handleInputChanges('title')}
                        onKeyUp={handleInputChanges('title')}
                        onBlur={() => validator.current.showMessageFor('Page Title')}
                        defaultValue={Inputs.title}
                        placeholder="Page Title"
                      />
                      {validator.current.message('Page Title', Inputs.title, 'required|max:60', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Short Description</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        name="description"
                        onChange={handleInputChanges('description')}
                        onKeyUp={handleInputChanges('description')}
                        onBlur={() => validator.current.showMessageFor('Description')}
                        defaultValue={Inputs.description}
                        placeholder="Short Description"
                      ></textarea>
                      {validator.current.message(
                        'Short Description',
                        Inputs.description,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>

                  {/* <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea className="form-control" name="description" onChange={handleInputChanges("description")} onKeyUp={handleInputChanges("description")} onBlur={() => validator.current.showMessageFor("Description")} defaultValue={Inputs.description} placeholder="Description"></textarea>
                                            {validator.current.message('Description', Inputs.description, 'required', { className: 'error' })}
                                        </div>
                                    </div> */}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <div>
                        <label>
                          Slug (URL)
                          <div className="note mt-1">{'(Slug contents only alphanumeric)'}</div>
                        </label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="slug"
                        min="1"
                        maxLength="50"
                        onChange={handleInputChanges('slug')}
                        onKeyUp={handleInputChanges('slug')}
                        onBlur={() => validator.current.showMessageFor('Slug')}
                        defaultValue={Inputs.slug}
                        placeholder="Slug"
                      />
                      {validator.current.message(
                        'Slug',
                        Inputs.slug,
                        'required|regex:^[a-z0-9][a-z-0-9]*[a-z0-9]$',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Publish Date
                        <div className="note mt-1">
                          {' '}
                          Select the date when this blog should be published.
                        </div>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="created_at"
                        onChange={handleInputChanges('created_at')}
                        value={Inputs.created_at}
                        placeholder="Publish Date"
                        min={new Date()}
                      />
                      {validator.current.message('Publish Date', Inputs.created_at, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label>Category</label>

                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          placeholder="Choose"
                          mode="multiSelect"
                          data={Categories}
                          onChange={onChangeCategory}
                          className="bootstrap-demo"
                        />
                      )}
                    </div>
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Content</label>
                      <ReactSummernote
                        name="content"
                        value={Content}
                        options={{
                          height: 300, // Set editor height
                          toolbar: [
                            ['style', ['bold', 'italic', 'underline', 'clear']],
                            [
                              'font',
                              [
                                'fontname',
                                'fontsize',
                                'strikethrough',
                                'superscript',
                                'subscript',
                                'style'
                              ]
                            ],
                            ['para', ['ul', 'ol', 'paragraph']],
                            ['insert', ['link', 'picture', 'video']],
                            ['view', ['fullscreen', 'codeview', 'help']]
                          ],
                          fontNames: [
                            'Arial',
                            'Arial Black',
                            'Comic Sans MS',
                            'Courier New',
                            'Georgia',
                            'Times',
                            'Verdana'
                          ],
                          fontSizeUnits: ['px', 'pt', '%']
                        }}
                        onChange={(e) => {
                          handleEditorChange(e)
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row"></div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="meta_title"
                        min="1"
                        maxLength="255"
                        onChange={handleInputChanges('meta_title')}
                        onKeyUp={handleInputChanges('meta_title')}
                        onBlur={() => validator.current.showMessageFor('Meta Title')}
                        defaultValue={Inputs.meta_title}
                        placeholder="Meta Title"
                      />
                      {/* {validator.current.message('Meta Title', Inputs.meta_title, 'required', {
                        className: 'error'
                      })} */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Meta Description</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        name="meta_description"
                        onChange={handleInputChanges('meta_description')}
                        onKeyUp={handleInputChanges('meta_description')}
                        onBlur={() => validator.current.showMessageFor('Meta Description')}
                        defaultValue={Inputs.meta_description}
                        placeholder="Meta Description"
                      ></textarea>
                      {/* {validator.current.message(
                        'Meta Description',
                        Inputs.meta_description,
                        'required',
                        { className: 'error' }
                      )} */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <p className="m-0">
                      Image{' '}
                      <label className="note">{'( Only PNG, JPEG, JPG format allowed.)'}</label>
                    </p>

                    <div
                      className="custom-file-container mb-4"
                      data-upload-id="blogImages"
                    >
                      {/* <div
                        style={IsImage ? { display: 'none' } : {}}
                        className="error pt-2 pb-4"
                      >
                        Image is required.
                      </div> */}
                    </div>
                    <div
                      style={!IsValidFile ? {} : { display: 'none' }}
                      className="error pt-2 pb-4"
                    >
                      {Messages.formatnotsupport}
                    </div>
                    <div
                      style={IsImageSize ? {} : { display: 'none' }}
                      className="error pt-0 pb-2"
                    >
                      File size shouldn&apos;t be greater than 2MB.
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Image Alt</label>
                      <input
                        type="text"
                        className="form-control"
                        name="image_alt"
                        min="1"
                        maxLength="255"
                        onChange={handleInputChanges('image_alt')}
                        onKeyUp={handleInputChanges('image_alt')}
                        // onBlur={() => validator.current.showMessageFor('image_alt')}
                        defaultValue={Inputs.image_alt}
                        placeholder="Image Alt"
                      />
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12 mt-1"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6"></div> */}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/blog"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddBlog
